'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _SHARE = require('components/SHARE');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _components2 = require('components');

require('./OrderItemsView.less');

var _windowOrGlobal = require('window-or-global');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderItemsView: {
        displayName: 'OrderItemsView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/default/OrderItemsView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderItemsView = _wrapComponent('OrderItemsView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(OrderItemsView, _Component);

    function OrderItemsView(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, OrderItemsView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderItemsView.__proto__ || (0, _getPrototypeOf2.default)(OrderItemsView)).call(this, props));

        _this.onPay = function (event) {
            event.preventDefault();
            _this.props.onPay(_this.props.comment, _this.props.deliveryAddress);
        };

        _this.renderTitleProduct = function (_ref) {
            var product = _ref.product,
                is_coupon = _ref.is_coupon;

            var offer = product.offer;
            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-4' },
                _react3.default.createElement(
                    'div',
                    { className: 'title prod_desc hidden-xs' },
                    _react3.default.createElement(
                        _reactRouter.Link,
                        { to: '/product/' + offer.id },
                        offer.name
                    ),
                    _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
                    product.custom_fields ? product.custom_fields.map(function (item, i) {
                        return _react3.default.createElement(
                            'label',
                            null,
                            item.name,
                            ': ',
                            item.value
                        );
                    }) : null
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'title visible-xs', style: { padding: '0' } },
                    _react3.default.createElement(
                        _reactRouter.Link,
                        { to: '/product/' + offer.id },
                        offer.name
                    ),
                    _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
                    product.custom_fields ? product.custom_fields.map(function (item, i) {
                        return _react3.default.createElement(
                            'label',
                            null,
                            item.name,
                            ': ',
                            item.value
                        );
                    }) : null
                )
            );
        };

        _this.renderTitleModifierOptionName = function (_ref2) {
            var offer = _ref2.offer;

            if (offer.modifier_option_name !== null && offer.modifier_option_name !== '') {
                return _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        offer.modifier_option_name
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc visible-xs', style: { padding: '0' } },
                        offer.modifier_option_name
                    )
                );
            } else if (offer.modifier_option_id !== null) {
                return _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        offer.modifiedOption.name
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc visible-xs', style: { padding: '0' } },
                        offer.modifiedOption.name
                    )
                );
            } else {
                return _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' });
            }
        };

        _this.renderQuantity = function (_ref3) {
            var quantity = _ref3.quantity;

            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-3' },
                _react3.default.createElement(
                    'div',
                    { className: 'quantity cart_quantity hidden-xs' },
                    _react3.default.createElement(
                        'span',
                        null,
                        quantity
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'quantity cart_quantity visible-xs', style: { padding: '0' } },
                    _react3.default.createElement(
                        'span',
                        { className: 'visible-xs' },
                        _this.props.lang['store.common.quantity'],
                        ': ',
                        quantity
                    )
                )
            );
        };

        _this.renderSum = function (_ref4) {
            var sum = _ref4.sum;
            var currency = _this.props.currency;

            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-2' },
                _react3.default.createElement(
                    'div',
                    { className: 'price cart_price hidden-xs' },
                    _react3.default.createElement(
                        'span',
                        { className: 'visible-xs' },
                        _this.props.lang['store.common.price'],
                        ': '
                    ),
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: sum,
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value
                    })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'price cart_price visible-xs', style: { padding: '0' } },
                    _react3.default.createElement(
                        'span',
                        { className: 'visible-xs' },
                        _this.props.lang['store.common.price'],
                        ': '
                    ),
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: sum,
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value
                    })
                )
            );
        };

        _this.renderImage = function (_ref5) {
            var _ref5$pictures = _ref5.pictures,
                pictures = _ref5$pictures === undefined ? [] : _ref5$pictures;


            var image = pictures[0];

            if (image && image.preview_url) {
                return _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-1' },
                    _react3.default.createElement('img', { src: image.preview_url })
                );
            }

            return _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' });
        };

        _this.renderProduct = function (item) {
            var price = parseFloat(item.base_price);
            var quantity = parseInt(item.quantity, 10) || 0;
            var weight = null;
            var childWeight = null;
            return _react3.default.createElement(
                'div',
                { key: item.id, className: 'row no-margin cart-item' },
                _react3.default.createElement(_this2.renderImage, { pictures: item.offer.pictures }),
                _react3.default.createElement(_this2.renderTitleProduct, { product: item, is_coupon: item.is_coupon || item.isCoupon }),
                _react3.default.createElement(_this2.renderTitleModifierOptionName, { offer: item }),
                _react3.default.createElement(_this2.renderQuantity, { quantity: quantity }),
                _react3.default.createElement(_this2.renderSum, { sum: price * quantity }),
                item.type_id === 5 ? item.childProducts.map(function (childItem) {
                    return _this.renderNested(childItem, quantity);
                }) : null
            );
        };

        _this.renderNested = function (childItem, quantity) {
            var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            if (childItem.quantity == 0) {
                return null;
            }
            var weight = childItem.quantity / quantity;
            childItem.weight_offer = childItem.weight_offer * 1;
            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
                weight = childItem.weight_offer * childItem.quantity / quantity;
                weight = weight.toFixed(3);
                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
                    weight = item.weight_offer * 1;
                }
                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
                    weight = childItem.weight_offer * 1;
                }
            }
            var paddingLeft = level * 30 + 'px';
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin', style: { clear: 'both' } },
                _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' }),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-4 visible-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        childItem.name,
                        ' ',
                        childItem.modifier_option_name
                    ),
                    _react3.default.createElement(
                        'div',
                        { style: { paddingLeft: paddingLeft } },
                        _react3.default.createElement(
                            'span',
                            null,
                            _this.props.lang['store.common.quantity'],
                            ': '
                        ),
                        childItem.type_id === 5 ? _react3.default.createElement(
                            'span',
                            null,
                            childItem.quantity / quantity
                        ) : _react3.default.createElement(
                            'span',
                            null,
                            weight,
                            ' ',
                            _this.props.lang[childItem.unit.title_lang_data]
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        childItem.name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        childItem.modifier_option_name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { style: { textAlign: 'center' } },
                        _react3.default.createElement(
                            'span',
                            { className: 'visible-xs' },
                            _this.props.lang['store.common.quantity'],
                            ': '
                        ),
                        childItem.type_id === 5 ? _react3.default.createElement(
                            'span',
                            null,
                            childItem.quantity / quantity
                        ) : _react3.default.createElement(
                            'span',
                            null,
                            weight,
                            ' ',
                            _this.props.lang[childItem.unit.title_lang_data]
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement('div', { className: 'price cart_price' })
                ),
                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
                    return _this.renderNested(childChildItem, quantity, level + 1);
                }) : null
            );
        };

        _this.renderMergedOrder = function () {
            var _this$props = _this.props,
                url = _this$props.url,
                sum = _this$props.sum,
                _this$props$before = _this$props.before,
                before = _this$props$before === undefined ? null : _this$props$before,
                _this$props$after = _this$props.after,
                after = _this$props$after === undefined ? null : _this$props$after,
                _this$props$showPay = _this$props.showPay,
                showPay = _this$props$showPay === undefined ? false : _this$props$showPay,
                token = _this$props.token,
                _this$props$paymentLi = _this$props.paymentList,
                paymentList = _this$props$paymentLi === undefined ? null : _this$props$paymentLi,
                _this$props$hideAll = _this$props.hideAll,
                hideAll = _this$props$hideAll === undefined ? false : _this$props$hideAll,
                lang = _this$props.lang,
                setting = _this$props.setting,
                delivery_address = _this$props.delivery_address,
                userAddresses = _this$props.userAddresses,
                addresses = _this$props.addresses,
                client_comment = _this$props.client_comment,
                onDeliveryAddressChange = _this$props.onDeliveryAddressChange,
                onDeliveryAddressSave = _this$props.onDeliveryAddressSave,
                onClientCommentChange = _this$props.onClientCommentChange,
                onAddAddress = _this$props.onAddAddress,
                isOrderWasPaid = _this$props.isOrderWasPaid,
                isRevert = _this$props.isRevert,
                currency = _this$props.currency,
                order_type_id = _this$props.order_type_id,
                childOrders = _this$props.childOrders,
                onChangeInput = _this$props.onChangeInput,
                addressOptions = _this$props.addressOptions,
                comment = _this$props.comment,
                deliveryAddress = _this$props.deliveryAddress,
                childOrdersAdditional = _this$props.childOrdersAdditional;


            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];
            var _setting$commentField = setting.commentFieldPlaceholder,
                commentFieldPlaceholder = _setting$commentField === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField,
                commentFieldShow = setting.commentFieldShow,
                deliveryFieldShow = setting.deliveryFieldShow,
                _setting$commentField2 = setting.commentFieldTitle,
                commentFieldTitle = _setting$commentField2 === undefined ? commentFieldTitleDefaultValue : _setting$commentField2;

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    _react3.default.createElement(
                        'h4',
                        null,
                        lang['store.postpone.combinesOrders'],
                        ':'
                    ),
                    childOrders.map(function (childOrder) {
                        return _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-4 text-center' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.postpone.postpone.orderNumber'],
                                    _react3.default.createElement(
                                        _reactRouter.Link,
                                        { to: '/personal/order/' + childOrder.id },
                                        childOrder.order_number
                                    )
                                ),
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.common.sum'] + ': ',
                                    _react3.default.createElement(_components2.MoneyValue, {
                                        value: childOrder.sum,
                                        icon: currency.icon,
                                        iconAfterValue: currency.icon_after_value
                                    })
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-8 text-center' },
                                deliveryFieldShow ? _react3.default.createElement(_components2.AddressInput
                                // id={childOrder.id}
                                , { placeholder: lang['store.common.delivery_address_placeholder'],
                                    value: childOrdersAdditional[childOrder.id].deliveryAddress,
                                    options: addressOptions,
                                    label: lang['store.common.delivery_address'],
                                    buttonText: lang['store.common.select_on_map'],
                                    onAddressChange: childOrdersAdditional[childOrder.id].onAddressChangeChildOrder,
                                    onAddAddress: onAddAddress
                                }) : null,
                                commentFieldShow ? _react3.default.createElement(
                                    _reactBootstrap.FormGroup,
                                    { className: 'col-xs-12 col-sm-12' },
                                    _react3.default.createElement(
                                        _reactBootstrap.ControlLabel,
                                        null,
                                        commentFieldTitle
                                    ),
                                    _react3.default.createElement(_reactBootstrap.FormControl
                                    // id_ert={childOrder.id}
                                    , { value: childOrdersAdditional[childOrder.id].comment,
                                        type: 'text',
                                        placeholder: commentFieldPlaceholder,
                                        onChange: childOrdersAdditional[childOrder.id].onCommentChangeChildOrder,
                                        componentClass: 'textarea',
                                        className: 'textarea_disable-resize'
                                    })
                                ) : null
                            )
                        );
                    })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'total_price items-holder' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(sum),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: lang['store.cart.total'] + ': '
                            })
                        )
                    )
                )
            );
        };

        _this.showCaptcha = function () {
            if (_this.props.showCaptcha) {
                return _react3.default.createElement(
                    _reactBootstrap.FormGroup,
                    null,
                    _this.props.showCaptcha()
                );
            }

            return '';
        };

        _this.renderCaptcha = function () {
            return _react3.default.createElement(
                _reactBootstrap.FormGroup,
                null,
                _this.props.renderCaptcha()
            );
        };

        return _this;
    }

    (0, _createClass3.default)(OrderItemsView, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var AccountsList = this.props.user.amount[0];
            var coupons = this.props.user.coupons;
            var _props = this.props,
                comment = _props.comment,
                deliveryAddress = _props.deliveryAddress,
                url = _props.url,
                _props$products = _props.products,
                products = _props$products === undefined ? [] : _props$products,
                sum = _props.sum,
                _props$before = _props.before,
                before = _props$before === undefined ? null : _props$before,
                _props$after = _props.after,
                after = _props$after === undefined ? null : _props$after,
                _props$paymentList = _props.paymentList,
                paymentList = _props$paymentList === undefined ? null : _props$paymentList,
                _props$disabled = _props.disabled,
                disabled = _props$disabled === undefined ? true : _props$disabled,
                bonusValue = _props.bonusValue,
                setting = _props.setting,
                lang = _props.lang,
                currency = _props.currency,
                onDeliveryAddressChange = _props.onDeliveryAddressChange,
                onAddAddress = _props.onAddAddress,
                onChangeInput = _props.onChangeInput,
                addressOptions = _props.addressOptions,
                sumDiscount = _props.sumDiscount,
                customFields = _props.customFields,
                changeCustomFields = _props.changeCustomFields,
                order_type_id = _props.order_type_id;


            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];

            var _setting$commentField3 = setting.commentFieldPlaceholder,
                commentFieldPlaceholder = _setting$commentField3 === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField3,
                commentFieldShow = setting.commentFieldShow,
                deliveryFieldShow = setting.deliveryFieldShow,
                _setting$commentField4 = setting.commentFieldTitle,
                commentFieldTitle = _setting$commentField4 === undefined ? commentFieldTitleDefaultValue : _setting$commentField4;


            var discountSum = (sum - sumDiscount) / 2;
            var addAmount = 0;
            if (sumDiscount > 0) {
                addAmount = sumDiscount * 1;
            }
            if (AccountsList.amount * 1 + addAmount > 0 && AccountsList.amount * 1 + addAmount < discountSum) {
                discountSum = AccountsList.amount * 1 + addAmount;
            }
            if (sum - discountSum < 1) {
                discountSum = sum - 1;
                if (discountSum < 0) discountSum = 0;
            }
            if (this.props.ibonus_data) {
                var IBonusData = _windowOrGlobal.JSON.parse(this.props.ibonus_data);
                if (IBonusData.discount_sum && IBonusData.discount_sum > discountSum) {
                    discountSum = IBonusData.discount_sum * 1;
                }
            }
            discountSum = Math.floor(discountSum);
            var totalSum = sum - sumDiscount - bonusValue;

            if (order_type_id === 7) {
                return _react3.default.createElement(
                    'section',
                    { id: 'cart-page' },
                    before,
                    this.props.failError.length > 0 ? _react3.default.createElement(
                        'div',
                        { className: 'row no-margin' },
                        _react3.default.createElement(
                            'div',
                            { className: 'small-12 columns' },
                            _react3.default.createElement(
                                'b',
                                null,
                                this.props.failError
                            )
                        )
                    ) : null,
                    this.renderMergedOrder(),
                    paymentList ? _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-8', style: { visibility: 'hidden' } },
                            paymentList
                        ) : _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-8' },
                            paymentList
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-sm-4 col-xs-12 text-center' },
                            _react3.default.createElement(
                                'div',
                                { className: 'buttons-holder inline_block button_width_100' },
                                sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
                                    'button',
                                    { onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
                                    lang['store.common.continue']
                                ) : _react3.default.createElement(
                                    'button',
                                    { disabled: disabled, onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
                                    lang['store.order_items.pay']
                                )
                            )
                        )
                    ) : null,
                    after
                );
            }

            var sumDiscountAmount = '';
            if (sumDiscount > 0) {
                sumDiscountAmount = _react3.default.createElement(
                    'div',
                    { className: 'items-holder' },
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: parseFloat(sumDiscount),
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value,
                        prefix: lang['store.common.discountInOrder'] + ': '
                    })
                );
            }
            var cashbackValue = '';
            var couponsSlider = '';
            var cashbackCoupon = '';
            var useCoupon = false;
            products.forEach(function (item) {
                if (item.is_coupon === true) {
                    useCoupon = true;
                }
            });
            setting.loyaltySettingsData = this.props.user.loyaltySettings;
            if (setting.loyaltySettingsActive && sum !== '0.00000000' && setting.loyaltySettingsData.customerSettings !== undefined && setting.loyaltySettingsData.newCustomerSettings !== undefined) {
                if (AccountsList.notFirstOrder !== true) {
                    if (setting.loyaltySettingsData.newCustomerSettings.coupon !== null && setting.loyaltySettingsData.newCustomerSettings.coupon !== undefined && setting.loyaltySettingsData.newCustomerSettings.coupon.deleted !== true) {
                        cashbackCoupon = _react3.default.createElement(
                            'div',
                            null,
                            lang['store.iBonus.order.afterPaymentCoupon'],
                            _react3.default.createElement(
                                'div',
                                { className: 'text-center', style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
                                setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath !== null ? _react3.default.createElement(
                                    'div',
                                    { className: 'text-center', style: { padding: '4px' } },
                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath })
                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
                                _react3.default.createElement(
                                    'div',
                                    null,
                                    setting.loyaltySettingsData.newCustomerSettings.coupon.header
                                )
                            )
                        );
                    }
                    if (setting.loyaltySettingsData.newCustomerSettings.cashBackType === 'percentage') {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
                                    ' ',
                                    (totalSum / 100 * setting.loyaltySettingsData.newCustomerSettings.amount).toFixed(2),
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    } else {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
                                    ' ',
                                    setting.loyaltySettingsData.newCustomerSettings.amount,
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    }
                } else {
                    if (setting.loyaltySettingsData.customerSettings.coupon !== null && setting.loyaltySettingsData.customerSettings.coupon !== undefined && setting.loyaltySettingsData.customerSettings.coupon.deleted !== true) {
                        cashbackCoupon = _react3.default.createElement(
                            'div',
                            null,
                            lang['store.iBonus.order.afterPaymentCoupon'],
                            _react3.default.createElement(
                                'div',
                                { style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
                                setting.loyaltySettingsData.customerSettings.coupon.imagePath !== null ? _react3.default.createElement(
                                    'div',
                                    { className: 'text-center', style: { padding: '4px' } },
                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.customerSettings.coupon.imagePath })
                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
                                _react3.default.createElement(
                                    'div',
                                    null,
                                    setting.loyaltySettingsData.customerSettings.coupon.header
                                )
                            )
                        );
                    }
                    if (setting.loyaltySettingsData.customerSettings.cashBackType === 'percentage') {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPoints'],
                                    ' ',
                                    (totalSum / 100 * setting.loyaltySettingsData.customerSettings.amount).toFixed(2),
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    } else {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPoints'],
                                    ' ',
                                    setting.loyaltySettingsData.customerSettings.amount,
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    }
                }
                if (coupons.length > 0) {
                    var couponStyleSelect = '';
                    couponsSlider = _react3.default.createElement(
                        'div',
                        { className: 'row no-margin summ_row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'total_price' },
                            lang['store.iBonus.order.availableCoupons']
                        ),
                        _react3.default.createElement(
                            'div',
                            { style: { overflow: 'auto' } },
                            _react3.default.createElement(
                                'table',
                                null,
                                _react3.default.createElement(
                                    'tbody',
                                    null,
                                    _react3.default.createElement(
                                        'tr',
                                        null,
                                        coupons.map(function (item, index) {
                                            couponStyleSelect = '4px solid #fff';
                                            if (_this3.props.couponId === item.id) {
                                                couponStyleSelect = '4px solid #008000';
                                            }
                                            if (item.imagePath !== null) {
                                                return _react3.default.createElement(
                                                    'td',
                                                    { key: index, style: { padding: '8px' } },
                                                    _react3.default.createElement(
                                                        'div',
                                                        { className: 'text-center',
                                                            style: { border: couponStyleSelect, borderRadius: '8px' } },
                                                        _react3.default.createElement(
                                                            'a',
                                                            { onClick: function onClick(e) {
                                                                    _this3.props.couponSelect(item);
                                                                } },
                                                            _react3.default.createElement(
                                                                'div',
                                                                { style: {
                                                                        maxWidth: '72px',
                                                                        maxHeight: '72px',
                                                                        padding: '4px'
                                                                    } },
                                                                _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px' },
                                                                    src: item.imagePath })
                                                            ),
                                                            _react3.default.createElement(
                                                                'div',
                                                                null,
                                                                item.header
                                                            )
                                                        )
                                                    )
                                                );
                                            } else {
                                                return _react3.default.createElement(
                                                    'td',
                                                    { style: { padding: '8px' } },
                                                    _react3.default.createElement(
                                                        'div',
                                                        { className: 'text-center',
                                                            style: { border: couponStyleSelect, borderRadius: '8px' } },
                                                        _react3.default.createElement(
                                                            'a',
                                                            { onClick: function onClick(e) {
                                                                    _this3.props.couponSelect(item);
                                                                } },
                                                            _react3.default.createElement('div', { style: {
                                                                    width: '72px',
                                                                    height: '72px',
                                                                    padding: '4px'
                                                                } }),
                                                            _react3.default.createElement(
                                                                'div',
                                                                null,
                                                                item.header
                                                            )
                                                        )
                                                    )
                                                );
                                            }
                                        })
                                    )
                                )
                            )
                        )
                    );
                }
            }
            return _react3.default.createElement(
                'section',
                { id: 'cart-page' },
                before,
                this.props.failError.length > 0 ? _react3.default.createElement(
                    'div',
                    { className: 'row no-margin' },
                    _react3.default.createElement(
                        'div',
                        { className: 'small-12 columns' },
                        _react3.default.createElement(
                            'b',
                            null,
                            this.props.failError
                        )
                    )
                ) : null,
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin cart-item hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-1 text-center' },
                        lang['store.cart.photo']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4' },
                        lang['store.cart.title']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2' },
                        lang['store.cart.modifiers']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 no-margin text-center' },
                        lang['store.cart.quantity']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 no-margin text-center' },
                        lang['store.cart.price']
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'items-holder' },
                    products.map(this.renderProduct)
                ),
                customFields.length > 0 ? _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    customFields.map(function (item, i) {
                        return _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-12 no-margin' },
                            item.type === 'text' ? _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    item.name
                                ),
                                _react3.default.createElement('input', {
                                    id: i,
                                    value: item.value,
                                    className: 'form-control',
                                    type: 'text',
                                    onChange: changeCustomFields
                                })
                            ) : _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement('input', { type: 'checkbox', className: 'form-check-input', id: i,
                                    onChange: changeCustomFields,
                                    checked: item.value }),
                                _react3.default.createElement(
                                    'label',
                                    { className: 'form-check-label', htmlFor: i },
                                    '\xA0 ',
                                    item.name
                                )
                            )
                        );
                    })
                ) : null,
                couponsSlider,
                AccountsList.amount > 0 && discountSum > 0 ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'div',
                        null,
                        lang['store.iBonus.order.bonusesToUseAreAvailable'],
                        ' ',
                        (AccountsList.amount * 1 + addAmount).toFixed(2)
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-2' },
                            lang['store.iBonus.order.bonusesUse']
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-6' },
                            _react3.default.createElement('input', { type: 'range', min: 0, max: discountSum, step: 1, value: bonusValue, onChange: this.props.onChangeBonusValue })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' }),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-3' },
                            '0'
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-3 text-right' },
                            discountSum
                        )
                    )
                ) : null,
                cashbackValue,
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin summ_row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'total_price items-holder' },
                            sumDiscountAmount,
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(totalSum),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: lang['store.cart.total'] + ': '
                            })
                        )
                    )
                ),
                deliveryFieldShow ? _react3.default.createElement(_components2.AddressInput, {
                    placeholder: lang['store.common.delivery_address_placeholder'],
                    value: deliveryAddress,
                    options: addressOptions,
                    label: lang['store.common.delivery_address'],
                    buttonText: lang['store.common.select_on_map'],
                    onAddressChange: onDeliveryAddressChange,
                    onAddAddress: onAddAddress
                }) : null,
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    commentFieldShow ? _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { className: 'col-xs-12 col-sm-7' },
                        _react3.default.createElement(
                            _reactBootstrap.ControlLabel,
                            null,
                            commentFieldTitle
                        ),
                        _react3.default.createElement(_reactBootstrap.FormControl, {
                            value: comment,
                            type: 'text',
                            placeholder: commentFieldPlaceholder,
                            onChange: onChangeInput,
                            componentClass: 'textarea',
                            className: 'textarea_disable-resize'
                        })
                    ) : null
                ),
                this.showCaptcha(),
                this.renderCaptcha(),
                paymentList ? _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-8', style: { visibility: 'hidden' } },
                        paymentList
                    ) : _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-8' },
                        paymentList
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-4 col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder inline_block button_width_100' },
                            sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
                                'button',
                                { onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
                                lang['store.common.continue']
                            ) : _react3.default.createElement(
                                'button',
                                { disabled: disabled, onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
                                lang['store.order_items.pay']
                            )
                        )
                    )
                ) : null,
                after
            );
        }
    }]);
    return OrderItemsView;
}(_react2.Component), _class.propTypes = {
    onPay: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    paymentList: _react2.PropTypes.any,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp));

exports.default = OrderItemsView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/default/OrderItemsView.jsx
// module id = 1714
// module chunks = 0